export default "__VITE_ASSET__C0FJFmSh__"